import {
  DeviceType,
  WebVisitPayload,
} from "../lib/features/webVisit/webVisit.types";
import {
  storage,
  STORAGE_KEYS,
  STORAGE_DURATIONS,
} from "../lib/storage/storage";

export const hasLoggedInSession = (): boolean => {
  return !storage.isExpired(
    STORAGE_KEYS.WEB_VISIT_LOGGED,
    STORAGE_DURATIONS.MINUTES_30,
  );
};

export const markLoggedInSession = (): void => {
  storage.setWithTimestamp(STORAGE_KEYS.WEB_VISIT_LOGGED);
};

export const isExternalReferrer = (referrer: string): boolean => {
  if (!referrer) return false;
  if (typeof window === "undefined") return false;

  try {
    const referrerUrl = new URL(referrer);
    const currentHostname = window.location.hostname;

    return referrerUrl.hostname !== currentHostname;
  } catch {
    return false;
  }
};

export const detectDeviceType = (userAgent: string): DeviceType => {
  if (/Mobi|Android/i.test(userAgent)) return "mobile";
  if (/Tablet|iPad/i.test(userAgent)) return "tablet";
  return "desktop";
};

export const extractTrackingData = (
  searchParams: URLSearchParams,
): Omit<WebVisitPayload, "referrer" | "url"> => {
  const user_agent =
    typeof navigator !== "undefined" ? navigator.userAgent : "";

  return {
    utm_source: searchParams.get("utm_source") || "",
    utm_medium: searchParams.get("utm_medium") || "",
    utm_campaign: searchParams.get("utm_campaign") || "",
    utm_term: searchParams.get("utm_term") || "",
    utm_content: searchParams.get("utm_content") || "",
    srsltid: searchParams.get("srsltid") || "",
    user_agent,
    device_type: detectDeviceType(user_agent),
  };
};

export const hasValidTrackingParams = (
  data: Omit<WebVisitPayload, "referrer" | "url">,
  referrer: string,
): boolean => {
  const hasUtmParams =
    data.utm_source ||
    data.utm_medium ||
    data.utm_campaign ||
    data.utm_term ||
    data.utm_content ||
    data.srsltid;

  const hasExternalReferrer = isExternalReferrer(referrer);

  return !!(hasUtmParams || hasExternalReferrer);
};

export const shouldLogWebVisit = (
  logged: boolean,
  data: Omit<WebVisitPayload, "referrer" | "url">,
  referrer: string,
): boolean => {
  if (logged) return false;

  if (hasLoggedInSession()) return false;

  if (!hasValidTrackingParams(data, referrer)) return false;

  return true;
};
